import React from "react"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"
import { showToast } from "utils"

export const prepareData = (experiences, categories) => {
  if (!experiences || experiences?.length === 0) {
    return []
  }

  let subRows = {}

  for (const exp of experiences) {
    if (!exp?.categories) {
      subRows = {
        ...subRows,
        ["others"]: [...(subRows?.others || []), exp],
      }
    } else {
      for (const category of exp?.categories) {
        subRows = {
          ...subRows,
          [category?.category_id]: [
            ...(subRows[category?.category_id] || []),
            { ...exp, order: category?.event_order },
          ],
        }
      }
    }
  }

  let data = categories?.map(category => {
    let events = subRows[category?.id] || []
    return {
      ...category,
      subRows: events.sort((a, b) => a.order - b.order),
    }
  })

  if (subRows?.others) {
    data.push({
      id: 0,
      name: "Other",
      subRows: subRows?.others?.sort((a, b) => a.order - b.order),
    })
  }

  return data
}

export const fieldRenderer = ({ input, placeholder, meta: { error } }) => {
  return (
    <div>
      <div>
        <input
          placeholder={placeholder}
          type="text"
          className="form-control"
          {...input}
        />
        {error && <span className={"input-error"}>{error}</span>}
      </div>
    </div>
  )
}

export const renderUsers = ({
  fields,
  meta: { error, submitFailed, touched },
}) => (
  <>
    <ul style={{ listStyleType: "none", padding: "0px" }}>
      {fields.map((user, index) => (
        <li key={index}>
          <Row className="my-2">
            <Col md={4}>
              <Field
                name={`${user}.first_name`}
                component={fieldRenderer}
                placeholder="First Name"
              />
            </Col>
            <Col md={4}>
              <Field
                name={`${user}.last_name`}
                component={fieldRenderer}
                placeholder="Last Name"
              />
            </Col>
            <Col md={3}>
              <Field
                name={`${user}.email`}
                component={fieldRenderer}
                placeholder="Email"
              />
            </Col>
            <Col xs={1}>
              <i
                className="bx bx-sm bx-x"
                style={{ cursor: "pointer" }}
                onClick={() => fields.remove(index)}
              ></i>
            </Col>
          </Row>
        </li>
      ))}
    </ul>
  </>
)

export const buildListDropdownOption = machine_name => {
  let option = {
    type: "list",
    text: null,
    machine_name: machine_name,
  }

  switch (machine_name) {
    case "documents":
    case "polls":
    case "surveys":
    case "questionnaires":
      option.text =
        machine_name.substr(0, 1).toUpperCase() +
        machine_name.substr(1, machine_name.length - 2) +
        " List"
      break

    case "lists":
      option.text = "List of Lists"
      break

    case "custom_web_links":
      option.text = "Web Link List"
      break

    case "trivia_challenge":
      option.text = "Trivia Challenge List"
      break

    case "comment_board":
      option.text = "Comment Board"
      break

    case "guest_list":
      option.text = "Attendee List"
      break

    case "private_message":
      option.text = "Private Messages"
      break

    case "leaderboard":
    case "livestream":
    case "camera":
      option.text =
        machine_name.substr(0, 1).toUpperCase() + machine_name.substr(1)
      break

    case "media":
       option.text = "Media Gallery"
      break

    case "countdown_clock":
      option.text = "Countdown Clock List"
      break

    case "calendar":
      option.text = "View Calendar Events"
      break

    case "register_guest":
      option.text = "Register Visitors"
      break

    case "refer_friend":
      option.text = "Refer a Friend"
      break

    case "booking_service":
      option.text = "Booking - Create a Booking"
      break

    case "view_bookings":
      option.text = "Booking - View Bookings"
      break

    case "form_builders":
      option.text = "Form Builder List"
      break

    case "places":
      option.text = "Places"
      break

    case "video_call":
      option.text = "Video Call"
      break

    default:
      option = null
      break
  }

  return option
}

export const buildSingleItemDropdownOption = machine_name => {
  let singleItem = {
    type: "entity",
    text: null,
    machine_name: machine_name,
  }

  switch (machine_name) {
    case "countdown_clock":
    case "trivia_challenge":
    case "basic_content":
      var txt1 = machine_name.replace(/_/g, " ")
      singleItem.text = txt1.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
      break

    case "documents":
    case "polls":
    case "surveys":
    case "lists":
    case "questionnaires":
      singleItem.text =
        machine_name.substr(0, 1).toUpperCase() +
        machine_name.substr(1, machine_name.length - 2)
      break

    case "custom_web_links":
      singleItem.text = "Web Link"
      break

    case "event_info":
      singleItem.text = "Event Info / RSVP"
      break

    case "form_builders":
      singleItem.text = "Form Builder"
      break

    default:
      singleItem = null
      break
  }

  return singleItem
}

export const copyButtonHandler = async text => {
  try {
    await navigator.clipboard.writeText(text)
    showToast("success", "Copied to clipboard!", "Success")
  } catch (error) {
    showToast("error", "Failed to copy!", "Error")
  }
}
